import { render, staticRenderFns } from "./swiperCom.vue?vue&type=template&id=29e34d2b&scoped=true"
import script from "./swiperCom.vue?vue&type=script&lang=js"
export * from "./swiperCom.vue?vue&type=script&lang=js"
import style0 from "./swiperCom.vue?vue&type=style&index=0&id=29e34d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e34d2b",
  null
  
)

export default component.exports